import getBucketsFromChildren from './getBucketsFromChildren';
import { FetchExperimentByName, FetchExperimentWithIdentifier, Cookies } from '../services';
import { getIdentifierFromAuthToken } from '../utilities';

let fetchExperiment = props => FetchExperimentWithIdentifier(props);
let fetchExperimentByName = props => FetchExperimentByName(props);

export function UpdateFetchExperiment(func) {
  fetchExperiment = func;
  fetchExperimentByName = func;
}

export const initializeExperimentState = (defaultBucket, buckets, previousValues) => ({
  ...previousValues,
  defaultBucket:
    defaultBucket || previousValues?.defaultBucket || 'control',
  buckets: [
    ...Array.from(new Set(
      (previousValues?.buckets || []).concat([...buckets, 'control'])
    ))
  ]
});

type optionsType = {
  identifier?: string;
};

export const fetchExperimentBucket = (options: optionsType = {}) => {
  const {
    identifier
  } = options;

  const shouldUseAuthEndpoint = !identifier;

  return shouldUseAuthEndpoint
    ? fetchExperimentByName(options)
    : fetchExperiment(options);
};

export const assignBucket = (assignedBucket, state, hasErrored = false) => ({
  ...state,
  assignedBucket,
  isLoading: false,
  hasErrored
});

const RegisterExperiment = async (props, updateExperiment) => {
  const {
    name,
    children,
    experiments,
    defaultBucket,
    serverCookies,
    identifier
  } = props;
  const buckets = children ? getBucketsFromChildren(children) : [];
  const existingExperiment = experiments[name];

  experiments[name] = initializeExperimentState(defaultBucket, buckets, experiments[name]);
  updateExperiment(name, experiments);

  const preloadedBucket = Cookies.get(name) || serverCookies[name];

  if (preloadedBucket) {
    experiments[name] = assignBucket(preloadedBucket, experiments[name]);
    return updateExperiment(name, experiments, false);
  }

  if (!existingExperiment) {
    const identifierToUse = identifier || getIdentifierFromAuthToken();
    const experimentOptions = { ...props, identifier: identifierToUse };
    const { assignedBucket } = await fetchExperimentBucket(experimentOptions);
    const hasErrored = !assignedBucket;
    experiments[name] = assignBucket(assignedBucket || defaultBucket, experiments[name], hasErrored);
  }

  return updateExperiment(name, experiments);
};

export default RegisterExperiment;
